import { request } from "./client";

function normalizeAnnouncement(a) {
  return {
    id: a?.id ?? "",
    title: a?.title ?? "(Untitled)",
    body: a?.body ?? a?.content ?? "",
    createdAt: a?.createdAt ?? null,
    updatedAt: a?.updatedAt ?? null,
  };
}

export const getAnnouncements = async () => {
  const res = await request("/announcements");
  const list = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
  return list.map(normalizeAnnouncement);
};
